import React, { useContext, useEffect, useState } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Close from "@material-ui/icons/Close";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import AuthContext from "context/AuthContext";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import { adminService } from "api/axios";

//import { dataTable } from "variables/general.js";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
};
const GET_CLIENTS_URL = 'api/Client';

const useStyles = makeStyles(styles);

export default function ClientListTable() {
  
  const authContext = useContext(AuthContext);
  const [clients,setClients] = useState([]);
   useEffect(()=> {
     const controller = new AbortController();
 
     const getClients = async () => {
         try {
             var bearerAuth = 'Bearer ' + authContext.user.token;
             const response = await adminService.get(GET_CLIENTS_URL, { headers: { 'Authorization': bearerAuth } })
             // now process the response
             setClients(response.data.clients);
             //            isMounted && setClientToken(response.d);
         } catch (err) {
             console.error(err);
         }
     }
 
     getClients();
 
     return () => {
         //isMounted = false;
         controller.abort();
     }
 }, [] )
  



 const data = 
  clients.map((client) => {
    return {
      id:  client.id ,
      name:  client.client_name ,
      primary_contact:  client.primary_contact.first_name + " " + client.primary_contact.last_name ,
      secondary_contact: client.secondary_contact.first_name + client.secondary_contact.last_name,
      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to add a edit kind of action */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              let obj = data.find((o) => o.id === client.id);
              alert(
                "You've clicked Edit button on \n{ \nID: " +
                  obj.id +
                  ", \nClient Name: " +
                  obj.name +
                  ", \nPrimary Contact: " +
                  obj.primary_contact +
                  ", \nsecondary_contact: " +
                  obj.secondary_contact +
                  "\n}."
              );
            }}
            color="warning"
            className="edit"
          >
            <Dvr />
          </Button>{" "}
          {/* use this button to remove the data row */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              //  let obj = data.find((o) => o.id === client.id);
                alert(
                  "You've clicked DeleteButton button on ");
            }}
            color="danger"
            className="remove"
          >
            <Close />
          </Button>{" "}
        </div>
      ),
    };
  }
);
const classes = useStyles();
return (
  <GridContainer>
    <GridItem xs={12}>
      <Card>
        <CardHeader color="primary" icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Current Clients</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            columns={[
              {
                Header: "ID",
                accessor: "id",
              },
              {
                Header: "Client Name",
                accessor: "name",
              },
              {
                Header: "Primary Cntact",
                accessor: "primary_contact",
              },
              {
                Header: "Secondary Contact",
                accessor: "secondary_contact",
              },
              {
                Header: "Actions",
                accessor: "actions",
              },
            ]}
            data={data}
          />
        </CardBody>
      </Card>
    </GridItem>
  </GridContainer>
);

}
